import { Add } from '@mui/icons-material';
import { Button } from '@mui/material';
import MapPoligons from 'components/MapPoligons'
import MenuDialog from 'components/dialog/MenuDialog';
import React, { useState } from 'react'

export const MapaApontamento = ({ outrosPoligonos, allTipos, selectTipoApontamento, label, icon, setTalhao, ...props }) => {
    const [dialog, setDialog] = useState();

    function handleShowDialog(talhao) {
        dialog.setOpen(true);
        setTalhao(talhao)
    }

    return (
        <>
            <MapPoligons
                name="areaNoMapStr"
                outrosPoligonos={outrosPoligonos}
                editPermissions={false}
                actionButton={true}
                AddApontamentoButton={(p) => {
                    return (
                        <Button sx={{}} icon={icon} onClick={() => handleShowDialog(p.talhao)} {...props}>
                            <Add sx={{ fontSize: "18px" }} />
                            <span>
                                Apontamento
                            </span>
                        </Button>
                    )
                }}
                showCurrentLocation
            />

            <MenuDialog title={label} setDialog={setDialog} {...props} menuItems={allTipos} onClose={selectTipoApontamento} />
        </>
    )
}
